import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-nc-jp': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.7 8c140.8 0 248.3 109.2 248.3 248 0 147.2-118.1 248-248.3 248-135.9 0-247.7-111.6-247.7-248 0-131.2 103.6-248 247.7-248zM248.3 458.7c118.1 0 173.7-96.1 175.2-98.3l-81-36.1v35.7h-64.2v56h-61.7v-56h-63.8v-38.7h63.8v-18.7l-5.7-11.8h-58.1v-38.6h27.9l-127-56.5c-6 19.1-9 39.2-9 60.3 0 110.2 91.6 202.7 203.6 202.7zM335.9 321.4l-54.7-24.3-2.9 5.6v18.7h57.6zM342.4 270l101 45.1c5.2-18.4 7.9-38 7.9-59 0-113.4-90.2-203.4-203-203.4-91.1 0-145.9 54-173.7 98.1l81.9 36.5-27.3-51h65.8l39.6 85.7 23 10.2 43.4-96h65.8l-63 116h38.6v17.8z'
      }
    ]
  }
})
